<template>
  <div class="content-body">
    <div class="modal fade" tabindex="-1" role="dialog" id="patientSelection">
      <div class="modal-dialog" role="document">
        <div>
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title label">Multiple Patients</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label class="label f-weight-550">Select the patient record you would like to manage</label>
              <button type="button" class="mb-1 mt-1 mr-1 btn btn-default btn-lg btn-block"
                v-for="patient in patientList" :key="patient.id" @click="patientSelect(patient)">
                {{ patient.firstName }} {{ patient.lastName }}
                <h6>
                  {{ patient.officeName }}
                </h6>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5 mr-2 ml-2 justify-content-md-center">
      <div class="col-lg-5 mt-5">
        <section class="card card-featured mb-4">
          <div class="card-body">
            <form @submit.prevent="login">
              <span>
                <h3 class="label">PORTAL LOGIN</h3>
              </span>
              <!-- to error: add class "has-danger" -->
              <div class="form-group">
                <label class="label f-weight-550">Email Address</label>
                <input type="email" class="form-control form-control-sm" required v-model="loginForm.userName" />
              </div>
              <div class="form-group mb-4">
                <label class="label f-weight-550">Password</label>
                <!-- <a href="#" style="float:right;font-size:12px;">Forgot password?</a> -->
                <input type="password" class="form-control form-control-sm" required v-model="loginForm.password" />
              </div>
              <btn-saving :is-saving="isSaving" :loading-text="'Validating...'" :display-text="'Login'" />
              <!-- <button type="submit" class="mb-1 mt-1 mr-5 btn btn-primary">
                Login
              </button> -->
              <router-link to="/account/forgotpassword" class="ml-3">
                Need help logging in?
              </router-link>
              <!-- <a href="javascript:void(0)" class="ml-3"
                >Need help logging in?</a
              > -->
            </form>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import '../../assets/FormLayout.css'
import api from '../../api/http-common.js'
import { mapGetters, mapActions } from 'vuex'
import BtnSaving from '../../components/button-saving.vue'
export default {
  components: {
    BtnSaving
  },
  data() {
    return {
      isSaving: false,
      loginForm: {
        userName: '',
        password: ''
      },
      patientList: [],
      selectedPatient: null,
      profileAuthInfo: null,
      linkInfo: null
    }
  },
  computed: {
    ...mapGetters(['currentPatientAssociated', 'getUrlLinkInfo', 'getTaskInfo'])
  },
  methods: {
    ...mapActions([
      'setIsLoading',
      'setProfileAuthInfo',
      'setProfilePatientAssociated',
      'setProfileCurrentPatient',
      'setTaskCurrentTaskType',
      'setMsgCurrentPage',
      'setCurrentMsgInfo',
      'setBillingStatementTask',
      'setTaskInfo',
      'setTaskItem',
      'clearUrlLinkInfo'
    ]),
    handlePatientSelectionModalClose() {
      // Reset the login state when modal is closed without selection
      this.isSaving = false
      this.patientList = []
      this.selectedPatient = null
      this.profileAuthInfo = null
    },
    async login() {
      try {
        // Set loading state to show saving indicator
        this.isSaving = true

        // Attempt to authenticate user with provided credentials
        let userData = await this.$auth.login(
          this.loginForm.userName,
          this.loginForm.password
        )
        if (!userData.success) {
          this.isSaving = false
          // Display error message for unsuccessful login
          this.$swal({
            position: 'top',
            title: 'Login Failed',
            text: 'Invalid email address or password. Please check your credentials and try again.',
            showConfirmButton: true,
            confirmButtonText: 'OK',
            icon: 'error'
          })
          return
        }
        // Check if there's a key in the URL query parameters
        // This is used for linking a new patient to an existing user account
        let newlyAttachedPatient = null
        if (this.$route.query.key) {
          // Fetch link information using the key from URL
          const resp = await api.auth.request.getLink(this.$route.query.key)
          if (resp.data) {
            console.log('resp.data', resp.data)
            // Store link information for later use
            this.linkInfo = resp.data

            // Create association between user and patient using link information from URL
            // This links an existing patient record to the authenticated user account
            await api.auth.request.insertUserPatient({
              patientPortalUserID: userData.userID,
              facilityId: this.linkInfo.facilityID,
              patientId: this.linkInfo.patientID,
              patientKey: this.linkInfo.patientKey,
              facilityKey: this.linkInfo.facilityKey,
              key: this.$route.query.key
            })

            // Re-authenticate user after patient association
            userData = await this.$auth.login(
              this.loginForm.userName,
              this.loginForm.password
            )

            // Store the newly attached patient info for later use
            newlyAttachedPatient = {
              facilityID: this.linkInfo.facilityID,
              patientID: this.linkInfo.patientID,
              patientKey: this.linkInfo.patientKey,
              facilityKey: this.linkInfo.facilityKey
            }
          }
        }
        // Store user authentication information
        this.profileAuthInfo = userData
        console.log('this.profileAuthInfo', this.profileAuthInfo)
        // Fetch all patients associated with this user
        const patientAssociated = await api.auth.request.getUserPatient(
          this.profileAuthInfo.userID
        )

        // If user has multiple patients associated with their account
        if (patientAssociated.data.length > 1) {
          // If a new patient was just attached, automatically select it
          if (newlyAttachedPatient) {
            // Find the newly attached patient in the patient list
            const attachedPatient = patientAssociated.data.find(patient =>
              patient.facilityID === newlyAttachedPatient.facilityID &&
              patient.patientID === newlyAttachedPatient.patientID
            )

            if (attachedPatient) {
              // Automatically select the newly attached patient
              this.selectedPatient = attachedPatient
              this.setProfilePatientAssociated(patientAssociated.data)
              await this.setProfileCurrentPatient(this.selectedPatient)
              await this.setProfileAuthInfo(this.profileAuthInfo)
              this.isSaving = false
              this.$auth.completeAuth()
              this.gotoTask()
              return
            }
          }

          // If no newly attached patient or couldn't find it, show patient selection modal
          this.patientList = patientAssociated.data
          // eslint-disable-next-line no-undef
          $('#patientSelection').modal({
            show: true,
            backdrop: 'static'
          })
        } else {
          // If user has only one patient, proceed with normal login flow
          // Store authentication info in Vuex store
          await this.setProfileAuthInfo(this.profileAuthInfo)
          // Store associated patient info
          this.setProfilePatientAssociated(patientAssociated.data)
          // Set current patient as the first (and only) patient
          await this.setProfileCurrentPatient(patientAssociated.data[0])
          // Reset loading state
          this.isSaving = false
          // Complete authentication process
          this.$auth.completeAuth()
          // Navigate to appropriate task page based on user's pending tasks
          this.gotoTask()
        }
      } catch (e) {
        // Handle any errors during login process
        console.error('Login error:', e)
        this.isSaving = false

        // Display user-friendly error message
        let errorMessage =
          'An unexpected error occurred during login. Please try again.'

        if (e.response && e.response.status) {
          switch (e.response.status) {
            case 401:
              errorMessage =
                'Invalid email address or password. Please check your credentials and try again.'
              break
            case 403:
              errorMessage =
                'Your account has been locked or disabled. Please contact support for assistance.'
              break
            case 404:
              errorMessage =
                'User account not found. Please check your email address or contact support.'
              break
            case 500:
              errorMessage =
                'Server error occurred. Please try again in a few minutes.'
              break
            default:
              errorMessage =
                'Login failed. Please check your credentials and try again.'
          }
        } else if (e.message) {
          if (
            e.message.includes('Network Error') ||
            e.message.includes('timeout')
          ) {
            errorMessage =
              'Unable to connect to the server. Please check your internet connection and try again.'
          } else {
            errorMessage = e.message
          }
        }

        this.$swal({
          position: 'top',
          title: 'Login Failed',
          text: errorMessage,
          showConfirmButton: true,
          confirmButtonText: 'OK',
          icon: 'error'
        })
      } finally {
        this.isSaving = false
      }
    },
    async patientSelect(patient) {
      if (patient) {
        this.selectedPatient = patient
      }
      this.setProfilePatientAssociated(this.patientList)
      await this.setProfileCurrentPatient(this.selectedPatient)
      // eslint-disable-next-line no-undef
      $('#patientSelection').modal('hide')
      await this.setProfileAuthInfo(this.profileAuthInfo)
      this.isSaving = false
      this.$auth.completeAuth()
      this.gotoTask() // added by Rizza Herrero 05/05/2021
      //       this.$router.push('/') commented out by Rizza Herrero 05/05/2021
    },
    async gotoTask() {
      try {
        // From link (e.g. after attaching patient): go to dashboard with flag; dash-task will "click" NPH.
        if (this.$route.query.key) {
          await this.$router.push({ path: '/', query: { fromLink: '1' } })
          return
        }
        this.$router.push('/')
      } catch (e) {
        this.$router.push('/')
      }
    }
  },
  mounted() {
    // Add event listener for when patientSelection modal is closed
    // eslint-disable-next-line no-undef
    $('#patientSelection').on(
      'hidden.bs.modal',
      this.handlePatientSelectionModalClose
    )
  },
  beforeDestroy() {
    // Clean up event listener when component is destroyed
    // eslint-disable-next-line no-undef
    $('#patientSelection').off(
      'hidden.bs.modal',
      this.handlePatientSelectionModalClose
    )
    this.clearUrlLinkInfo()
  }
}
</script>

<style scoped></style>
